<template>
    <a-layout-content>
        <!-- <keep-alive> -->
            <router-view />
        <!-- </keep-alive> -->
    </a-layout-content>
</template>

<script>
export default {
    name: "index.lembur",
    data() {
        return {};
    }
};
</script>

<style>
</style>
  